import Modal from 'react-modal';
import { Container } from '@mui/material';
import { Close } from '@shared/assets';
import { enableScroll } from '@shared/helpers';
import { useAppDispatch } from '@shared/hooks';
import { IconButton } from '@shared/ui';
import { Button } from 'library/components/common';
import { closeOutModal } from 'library/redux/modal';
import { useLogout } from './model';
import styles from './styles.module.scss';

export const ModalOut = () => {
  const dispatch = useAppDispatch();
  const { logout } = useLogout();

  const closeModal = () => {
    enableScroll();
    dispatch(closeOutModal());
  };

  const logOut = async () => {
    enableScroll();
    await logout();
    dispatch(closeOutModal());
  };

  return (
    <Modal
      isOpen
      ariaHideApp={false}
      className={styles.out}
      overlayClassName={styles.out__overlay}
      onRequestClose={closeModal}
    >
      {/* <HeadModal title={'Выход'} /> */}
      <Container
        disableGutters
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '50px',
          background: '#F1F2F3',
          borderRadius: '10px 10px 0 0',
        }}
      >
        <div className={styles.close}>
          <IconButton variant={'white'} onClick={closeModal}>
            <Close />
          </IconButton>
        </div>
        <div className={styles.head}>Выход</div>
      </Container>
      <div className={styles.wrapper}>
        <div className={styles.out__text}>Выйти из аккаунта?</div>
        <div className={styles.out__group}>
          <Button className={styles.button} cancel handler={() => closeModal()}>
            Отмена
          </Button>
          <Button className={styles.button} handler={() => logOut()}>
            Выйти
          </Button>
        </div>
      </div>
    </Modal>
  );
};
